import { FC, PropsWithChildren, ReactNode } from "react";
import { NavLink, useLocation } from "react-router-dom";
import useUrl from "../../hooks/useUrl";

const SideBarNavLink: FC<PropsWithChildren<{
  to: string,
  onClick?: () => unknown,
  isCurrent?: boolean,
  icon?: ReactNode,
}>> = ({
  children,
  to,
  onClick,
  isCurrent = false,
  icon,
}) => {
  const { isCurrentUrl } = useUrl();

  return (
    <NavLink
      to={to}
      {...(onClick ? { onClick } : {})}
      className={`
        py-3 px-4 rounded-lg flex gap-2 [&>svg]:opacity-20 items-center
        ${isCurrent || isCurrentUrl(to)
          ? 'bg-bg_dark text-text'
          : 'hover:text-primary hover:bg-slate-100'
        }
      `}                    
    >
      {icon || ''}
      {children}
    </NavLink>
  );
}



export default SideBarNavLink;
